export function getOrderedWeekdays(start = 1) {
    return [...Array(7).keys()].map((n) => {
        const weekDay = start + n >= 7 ? start + n - 7 : start + n;
        return weekDay;
    });
}
//# sourceMappingURL=getOrderedWeekdays.js.map